export const adjustBrightness = `
vec3 adjustBrightness(vec3 color, float value) {
  return color + value;
}
`;
